import Vue from 'vue'
import Vuex from 'vuex'
import colors from './ColorModule'
import modals from './Modals'
import builder from './Builder'
import temporaryCloseableElements from './TemporaryCloseableElements'
import router from '../router'
import axios from 'axios'
import moment from 'moment'
import {
  managedEvent,
  userTourPasses,
  favouriteEventIds,
  groupEditor,
  managerMenu,
} from './StoreQueries'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    colors,
    modals,
    builder,
    temporaryCloseableElements,
  },
  state: {
    userSubscription: null,
    subscriptionModalTexts: {
      textToShow: '',
      groupScoring: 'Upgrade to the Pro plan to start using Group Scoring.',
      verifier: 'Upgrade to the Pro plan to start using the Verifier.',
      signature: 'Upgrade now to start using the Signature.',
      autoOpen: 'Upgrade now to start using registration opening automation.',
      reigstrationType: 'Upgrade now to start using flex and group signup.',
      additionalInformation:
        'Upgrade now to start using additional information sections.',
      checkIn: 'Upgrade now to start using Check-in.',
      rounds: 'Upgrade now to add 2 rounds.',
      unlimitedRounds: 'Upgrade to the Pro plan to add more than 2 rounds.',
      pools: 'Upgrade to the Pro plan to start using Pools.',
      startingFormat: 'Upgrade now to set teetime starts.',
      playerExport: 'Upgrade to the Pro plan to access the player export.',
      interestsExport: 'Upgrade now to access the interests export.',
      resultExport: 'Upgrade to the Pro plan to access the results export.',
      standingsExport: 'Upgrade now to access the standings export.',
      tiebreaker: 'Upgrade to the Pro plan to set tiebreaks.',
      stages: 'Upgrade to the Pro plan to start using registration stages.',
      questions:
        'Upgrade to the Pro plan to start using registration questions.',
      dynamicPoints: 'Upgrade now to start using dynamic points.',
      customPoints: 'Upgrade now to start using custom points.',
      points: 'Upgrade now to start using dynamic and custom points.',
      documents: 'Upgrade to the Pro plan to upload documents.',
      pause: 'Upgrade to the Pro plan to Pause pools and rounds.',
      marshall: 'Upgrade to the Pro plan to start using Marshalls.',
    },
    adUnits: {
      // PRD Environment
      PRD: {
        dashboard_top_banner: {
          adUnitPath: '/23295702748/PRD_dashboard_top_banner',
          adSlotId: 'div-gpt-ad-1751619328712-0',
        },
        event_search_banner: {
          adUnitPath: '/23295702748/PRD_event_search_banner',
          adSlotId: 'div-gpt-ad-1751619432202-0',
        },
        events_top_banner: {
          adUnitPath: '/23295702748/PRD_events_top_banner',
          adSlotId: 'div-gpt-ad-1751619545000-0',
        },
        tours_top_banner: {
          adUnitPath: '/23295702748/PRD_tours_top_banner',
          adSlotId: 'div-gpt-ad-1751619634347-0',
        },
      },
      // DEV/Staging Environment
      DEV: {
        dashboard_top_banner: {
          adUnitPath: '/23295702748/dashboard_top_banner',
          adSlotId: 'div-gpt-ad-1751619689728-0',
        },
        event_search_banner: {
          adUnitPath: '/23295702748/event_search_banner',
          adSlotId: 'div-gpt-ad-1751619742142-0',
        },
        events_top_banner: {
          adUnitPath: '/23295702748/ABCD1234',
          adSlotId: 'div-gpt-ad-1756900232469-0',
        },
        tours_top_banner: {
          adUnitPath: '/23295702748/tours_top_banner',
          adSlotId: 'div-gpt-ad-1751619854150-0',
        },
      },
    },
    returnToRoute: null,
    groupEditorData: null,
    managerMenuData: null,
    messages: {
      show: false,
      message: '',
      timer: 1500,
      type: 'success',
      style: 'midnight',
    },
    currencyMinimumChargeAmount: {
      SEK: 3,
      DKK: 2.5,
      NOK: 3,
      AUD: 0.5,
      GBP: 0.3,
      EUR: 0.5,
      USD: 0.5,
    },
    currencyFormats: {
      SEK: { code: 'SEK', symbol: 'kr' },
      DKK: { code: 'DKK', symbol: 'kr' },
      NOK: { code: 'NOK', symbol: 'kr' },
      AUD: { code: 'AUD', symbol: '$' },
      GBP: { code: 'GBP', symbol: '£' },
      EUR: { code: 'EUR', symbol: '€' },
      USD: { code: 'USD', symbol: '$' },
      JPY: { code: 'JPY', symbol: '¥' },
      NZD: { code: 'NZD', symbol: '$' },
    },
    currentlyManagedEvent: {
      data: null,
      myCourses: null,
      loaded: false,
    },
    eventDivisionPools: [],
    eventMessages: [],
    eventMessagesMeta: null,
    eventInformation: {
      showEventInfo: false,
      showInfo: false,
      details: {},
    },
    poolConversion: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
    loginProcess: {
      invalidEmail: false,
      invalidPassword: false,
    },
    eventDivisions: [],
    user: {
      watchedEvents: [],
      watchedEventsLoaded: false,
      tourPasses: [],
      registrations: [],
      favouriteEvents: [],
      favouriteEventsIds: [],
      isAuthenticated: false,
      authCheckCompleted: false,
      isVerified: false,
      hasUnpaidInvoices: false,
      emailVerifyInformation: {
        showBanner: false,
        closedDateTime: {},
      },
      eventRegistrations: [],
      sessionInfo: {
        expireAt: '',
        token: '',
        userId: '',
      },
      openPools: [],
      scorecards: [],
      firstName: '',
      lastName: '',
      email: '',
    },
    utility: {
      showTopNav: true,
      showFooter: true,
      showMobileMenu: false,
      deviceWidth: 0,
      escapePressed: false,
      loading: false,
      loadingTimeStamp: moment().valueOf(),
      onTjingMobile: navigator.userAgent.includes('tjing-mobile-app'),
    },
  },
  mutations: {
    validateUserAuthState(state, payload) {
      state.user.isAuthenticated = payload
      state.user.authCheckCompleted = true
    },
    updateEventDivisionPools(state, payload) {
      state.eventDivisionPools = payload
    },
    updateSubscriptionStatus(state, payload) {
      state.userSubscription = payload
    },
    setSubscriptionModalTextToUse(state, payload) {
      state.subscriptionModalTexts.textToShow = payload
    },
    loadGroupEditorData(state, payload) {
      state.groupEditorData = payload
    },
    loadManagerMenuData(state, payload) {
      state.managerMenuData = payload
    },

    async loadFavouriteEventsIds(state) {
      try {
        const favouriteEvents = await axios({
          headers: { Authorization: state.user.sessionInfo.token },
          data: {
            query: favouriteEventIds,
          },
        })

        state.user.favouriteEventsIds =
          favouriteEvents.data.data.me.favouriteEvents
      } catch (err) {
        console.log(err)
      }
    },
    async loadFavouriteEvents(state) {
      try {
        const favouriteEvents = await axios({
          headers: { Authorization: state.user.sessionInfo.token },
          data: {
            query: favouriteEvents,
          },
        })

        state.user.favouriteEvents =
          favouriteEvents.data.data.me.favouriteEvents
      } catch (err) {
        console.log(err)
      }
    },
    setEventMessages(state, eventMessages) {
      state.eventMessages = eventMessages
    },
    setEventMessagesMeta(state, payload) {
      state.eventMessagesMeta = payload
    },
    setReturnToRouteData(state, routeInfo) {
      state.returnToRoute = routeInfo
    },
    showMessage(state, messageObject) {
      state.messages.message = messageObject.message
      state.messages.type = messageObject.type
      state.messages.style = messageObject.style
      state.messages.timer =
        messageObject.timer === undefined ? 4000 : messageObject.timer
      state.messages.show = true
    },

    hideMessage(state) {
      state.messages.show = false
      state.messages.timer = 1500
    },
    hideEmailVerificationBanner(state) {
      state.user.emailVerifyInformation.showBanner = false
      state.user.emailVerifyInformation.closedDateTime = moment()
    },
    authenticationState(state, bool) {
      state.user.isAuthenticated = bool
    },
    toggleMobileMenu(state, bool) {
      state.utility.showMobileMenu = bool
    },
    setFooterState(state, bool) {
      state.utility.showFooter = bool
    },
    setMainNavState(state, bool) {
      state.utility.showTopNav = bool
    },
    showEventInfo(state, bool) {
      state.eventInformation.showEventInfo = bool
    },
    showEventInfoBody(state, bool) {
      state.eventInformation.showInfo = bool
    },
    setEventInfo(state, information) {
      state.eventInformation.details = information
    },
    toggleLoading(state, bool) {
      let timer = moment().valueOf() - state.utility.loadingTimeStamp

      if (bool == true) {
        state.utility.loadingTimeStamp = moment().valueOf()
        state.utility.loading = bool

        setTimeout(() => {
          state.utility.loading = false
        }, 3000)
      }

      if (timer < 1750 && bool == false) {
        setTimeout(() => {
          state.utility.loading = false
        }, 1750 - timer)
      }
    },
    escapePressed(state) {
      state.utility.escapePressed = true
      Vue.nextTick(function () {
        state.utility.escapePressed = false
      })
    },
    deviceWidth(state, payload) {
      state.utility.deviceWidth = payload
    },
    logout(state) {
      localStorage.removeItem('userObject')
      state.user = {
        hasUnpaidInvoices: false,
        authCheckCompleted: true,
        watchedEvents: [],
        watchedEventsLoaded: false,
        tourPasses: [],
        registrations: [],
        isAuthenticated: false,
        isVerified: false,
        emailVerifyInformation: {
          showBanner: false,
          closedDateTime: {},
        },
        eventRegistrations: [],
        sessionInfo: {
          expireAt: '',
          token: '',
          userId: '',
          isPremium: false,
        },
        openPools: [],
        scorecards: [],
        firstName: '',
        lastName: '',
        email: '',
      }

      document.cookie =
        'authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      document.cookie =
        'authToken=; Secure; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    },
    setSessionInfo(state, sessionInfo) {
      state.user.firstName = sessionInfo.firstName
      state.user.lastName = sessionInfo.lastName
      state.user.email = sessionInfo.email
      state.user.hasUnpaidInvoices = sessionInfo.hasUnpaidInvoices
      state.user.sessionInfo = sessionInfo
      state.utility.escapePressed = true
      Vue.nextTick(function () {
        state.utility.escapePressed = false
      })
    },
    setUserInfo(state, userInfo) {
      state.user.hasUnpaidInvoices = userInfo.hasUnpaidInvoices
      state.user.firstName = userInfo.firstName
      state.user.lastName = userInfo.lastName
      state.user.email = userInfo.email
    },
    setEventDivisions(state, divisions) {
      state.eventDivisions = divisions
    },
    updateProfileImage(state, imageUrl) {
      state.user.sessionInfo.profileImageUrl = imageUrl
    },
    removeWatchedEvent(state, event) {
      state.user.watchedEvents = state.user.watchedEvents.filter((watched) => {
        return watched != event
      })
    },
    addWatchedEvent(state, event) {
      state.user.watchedEvents.push(event)
    },
    async getUserTourPasses(state, payload) {
      state.user.tourPasses = payload
    },

    async showVerifyEmailBanner(state, payload) {
      if (state.utility.onTjingMobile) {
        state.user.emailVerifyInformation.showBanner = false
      } else {
        state.user.emailVerifyInformation.showBanner = payload
      }
    },
    async loadManagedEventData(state, payload) {
      try {
        let eventData = await axios({
          headers: { Authorization: state.user.sessionInfo.token },
          data: {
            query: managedEvent(payload),
          },
        })

        eventData.data.data.event.rounds.forEach((round) => {
          round.pools.forEach((pool) => (pool.createGroupsMethod = 'RANDOM'))
        })

        state.currentlyManagedEvent.data = eventData.data.data.event
        state.currentlyManagedEvent.myCourses = eventData.data.data.me.courses
        state.currentlyManagedEvent.loaded = true
      } catch (err) {
        console.log(err)
      }
    },
  },
  actions: {
    updateEventDivisionPools(action, payload) {
      action.commit('updateEventDivisionPools', payload)
    },
    async validateUserAuthState({ commit, state }, token) {
      try {
        const authState = await axios({
          headers: { Authorization: token },
          data: {
            query: `{
              isAuthenticated
              me {
                id
                email
                isVerified
                hasUnpaidInvoices
                firstName
                lastName
                isPremium
                profile{
                  profileImageUrl
                }
                subscription{
                  status
                  tier
                }
              }
            }`,
          },
        })

        if (
          !authState.data ||
          !authState.data.data ||
          !authState.data.data.isAuthenticated
        ) {
          commit('validateUserAuthState', false)
          return false
        }

        let subscriptionTier = 'FREE'

        const hasActiveSubscription =
          authState.data.data.me.subscription?.status === 'active'
        if (hasActiveSubscription) {
          subscriptionTier = authState.data.data.me.subscription.tier
        }
        const sessionInfo = {
          email: authState.data.data.me.email,
          firstName: authState.data.data.me.firstName,
          lastName: authState.data.data.me.lastName,
          profileImageUrl: authState.data.data.me.profile.profileImageUrl,
          token,
          userId: authState.data.data.me.id,
          subscriptionTier: subscriptionTier,
          hasUnpaidInvoices: authState.data.data.me.hasUnpaidInvoices,
          isPremium: authState.data.data.me.isPremium,
        }

        commit('setSessionInfo', sessionInfo)

        document.cookie = `authToken=${token}; Secure; expires=${new Date(
          2147483647 * 1000
        ).toUTCString()}; path=/`

        commit('validateUserAuthState', true)

        if (
          authState.data.data.me.isVerified == false &&
          !state.utility.onTjingMobile
        ) {
          commit('showVerifyEmailBanner', true)
        }

        return true
      } catch (err) {
        console.log(err)
        commit('validateUserAuthState', false)
        return false
      }
    },
    updateSubscriptionStatus(action, payload) {
      action.commit('updateSubscriptionStatus', payload)
    },
    setSubscriptionModalTextToUse(action, payload) {
      action.commit('setSubscriptionModalTextToUse', payload)
    },
    async getUserTourPasses({ commit, state }, payload) {
      try {
        const tourPasses = await axios({
          headers: { Authorization: state.user.sessionInfo.token },
          data: {
            query: userTourPasses,
          },
        })

        commit('getUserTourPasses', tourPasses.data.data.me.tourPasses)
        return tourPasses
      } catch (err) {
        console.log(err)
      }
    },
    async loadGroupEditorData({ commit, state }, payload) {
      try {
        const groupEditorData = await axios({
          headers: { Authorization: state.user.sessionInfo.token },
          data: {
            query: groupEditor(payload),
          },
        })

        groupEditorData.data.data.event.rounds.forEach((round) => {
          round.pools.forEach((pool) => {
            pool.defaultNewStartHole = pool.layoutVersion.holes[0].id
            pool.showOptions = false
            pool.teeTimeSortOrder = 'asc'
          })
        })

        commit('loadGroupEditorData', groupEditorData.data.data.event)
        commit(
          'setEventDivisions',
          groupEditorData.data.data.event.tour.divisions
        )

        return groupEditorData
      } catch (err) {
        console.log(err)
      }
    },
    async loadManagerMenuData({ commit, state }, payload) {
      try {
        const managerMenuData = await axios({
          headers: { Authorization: state.user.sessionInfo.token },
          data: {
            query: managerMenu(payload),
          },
        })

        commit('loadManagerMenuData', managerMenuData.data.data.event)

        return managerMenuData
      } catch (err) {
        console.log(err)
      }
    },
    loadFavouriteEventsIds(action) {
      action.commit('loadFavouriteEventsIds')
    },
    loadFavouriteEvents(action) {
      action.commit('loadFavouriteEvents')
    },
    setEventMessages(action, eventMessages) {
      action.commit('setEventMessages', eventMessages)
    },
    setEventMessagesMeta(action, payload) {
      action.commit('setEventMessagesMeta', payload)
    },
    setReturnToRouteData(action, routeInfo) {
      action.commit('setReturnToRouteData', routeInfo)
    },
    removeWatchedEvent(action, eventId) {
      action.commit('removeWatchedEvent', eventId)
    },
    addWatchedEvent(action, eventId) {
      action.commit('addWatchedEvent', eventId)
    },
    loadManagedEventData(action, payload) {
      action.commit('loadManagedEventData', payload)
    },
    disableEmailVerificationBanner(action) {
      action.commit('hideEmailVerificationBanner')
    },
    hideEmailVerificationBanner(action) {
      if (localStorage.getItem('dataFetchedTimestamps')) {
        let timeStamps = JSON.parse(
          localStorage.getItem('dataFetchedTimestamps')
        )
        timeStamps.closedDateTime = moment()
        localStorage.setItem(
          'dataFetchedTimestamps',
          JSON.stringify(timeStamps)
        )
        action.commit('hideEmailVerificationBanner')
      } else {
        let timeStamps = {
          closedDateTime: moment(),
        }

        localStorage.setItem(
          'dataFetchedTimestamps',
          JSON.stringify(timeStamps)
        )
        action.commit('hideEmailVerificationBanner')
      }
    },
    showMessage(action, messageObject) {
      action.commit('showMessage', messageObject)
    },
    hideMessage(action) {
      action.commit('hideMessage')
    },
    authenticationState(action, bool) {
      action.commit('authenticationState', bool)
    },
    toggleMobileMenu(action, bool) {
      action.commit('toggleMobileMenu', bool)
    },
    checkForOpenGroups(action, bypass) {
      if (localStorage.getItem('dataFetchedTimestamps')) {
        let timeStamps = JSON.parse(
          localStorage.getItem('dataFetchedTimestamps')
        )

        if (
          moment(timeStamps.scorecardCheck).add(30, 'seconds').isBefore() ||
          bypass
        ) {
          action.commit('activeScorecards')

          timeStamps.scorecardCheck = moment()
          localStorage.setItem(
            'dataFetchedTimestamps',
            JSON.stringify(timeStamps)
          )
        }
      } else {
        let timeStamps = {
          scorecardCheck: moment(),
        }

        localStorage.setItem(
          'dataFetchedTimestamps',
          JSON.stringify(timeStamps)
        )
      }
    },
    updateProfileImage(action, imageUrl) {
      action.commit('updateProfileImage', imageUrl)
    },
    setFooterState(action, bool) {
      action.commit('setFooterState', bool)
    },
    setMainNavState(action, bool) {
      action.commit('setMainNavState', bool)
    },
    setEventInfo(action, information) {
      action.commit('setEventInfo', information)
    },
    showEventInfo(action, bool) {
      action.commit('showEventInfo', bool)
    },
    showEventInfoBody(action, bool) {
      action.commit('showEventInfoBody', bool)
    },
    setEventDivisions(action, divisions) {
      action.commit('setEventDivisions', divisions)
    },
    setSessionInfo(action, sessionInfo) {
      action.commit('setSessionInfo', sessionInfo)
    },
    setUserInfo(action, userInfo) {
      action.commit('setUserInfo', userInfo)
    },
    toggleLoading(action, bool) {
      action.commit('toggleLoading', bool)
    },
    escapePressed(action) {
      action.commit('escapePressed')
    },
    deviceWidth(action, payload) {
      action.commit('deviceWidth', payload)
    },
    logout(action) {
      if (router.currentRoute.path !== '/') {
        router.push({ path: '/' }).catch(() => {})
      }

      action.commit('logout')
    },
  },
  getters: {
    eventDivisionPools: (state) => {
      return state.eventDivisionPools
    },
    subscriptionTier(state) {
      return state.user.sessionInfo.subscriptionTier
    },
    isPremium(state) {
      // Default to false if sessionInfo is not available
      return state.user.sessionInfo?.isPremium || false
    },
    hasActiveSubscription(state) {
      return state.userSubscription
        ? state.userSubscription.status === 'active'
        : false
    },
    getManagerMenuData(state) {
      return state.managerMenuData
    },

    getGroupEditorData(state) {
      return state.groupEditorData
    },
    favouriteEventIds: (state) => {
      return state.user.favouriteEventsIds || []
    },
    favouriteEvents: (state) => {
      return state.user.favouriteEvents
    },
    eventMessages: (state) => {
      return state.eventMessages
    },
    onTjingMobile: (state) => {
      return state.utility.onTjingMobile
    },
    returnToRoute: (state) => {
      return state.returnToRoute
    },
    watchedEvents: (state) => {
      return state.user.watchedEvents
    },
    watchedEventsLoaded: (state) => {
      return state.user.watchedEventsLoaded
    },
    managedEvent: (state) => {
      return state.currentlyManagedEvent
    },
    deviceWidth: (state) => {
      return state.utility.deviceWidth
    },
    showEmailVerificationBanner: (state) => {
      return state.user.emailVerifyInformation.showBanner
    },
    registrations: (state) => {
      return state.user.registrations
    },
    tourPasses: (state) => {
      return state.user.tourPasses
    },
    eventDivisions: (state) => {
      return state.eventDivisions
    },
    showMessage: (state) => {
      return state.messages
    },
    showItems: (state) => {
      return state.utility
    },
    openPools: (state) => {
      return state.user.openPools
    },
    showMobileMenu: (state) => {
      return state.utility.showMobileMenu
    },
    userScorecards: (state) => {
      return state.user.scorecards
    },
    showFooter: (state) => {
      return state.utility.showFooter
    },
    showTopNav: (state) => {
      return state.utility.showTopNav
    },
    eventInformation: (state) => {
      return state.eventInformation
    },
    userInitials: (state, getters) => {
      if (getters.isUserLoggedIn) {
        return state.user.firstName.charAt(0) + state.user.lastName.charAt(0)
      }
    },
    escapePressed: (state) => {
      return state.utility.escapePressed
    },
    userInfo: (state) => {
      return state.user
    },
    isUserLoggedIn: (state) => {
      return state.user.isAuthenticated
    },
    authCheckCompleted: (state) => {
      return state.user.authCheckCompleted
    },
    // Ad unit getters
    currentEnvironment: () => {
      // Use environment variable for ad environment configuration
      const adEnvironment = process.env.VUE_APP_AD_ENVIRONMENT

      // Validate the environment variable
      if (adEnvironment && ['PRD', 'DEV'].includes(adEnvironment)) {
        return adEnvironment
      }

      // Fallback: Check if we're in production environment based on NODE_ENV
      if (process.env.NODE_ENV === 'production') {
        return 'PRD'
      }

      // Default to DEV for development
      return 'DEV'
    },
    isProductionEnvironment: () => {
      // Use environment variable first
      const adEnvironment = process.env.VUE_APP_AD_ENVIRONMENT
      if (adEnvironment === 'PRD') {
        return true
      }
      if (adEnvironment === 'DEV') {
        return false
      }

      // Fallback to NODE_ENV
      return process.env.NODE_ENV === 'production'
    },
    getAdUnitConfig: (state, getters) => (adUnitName) => {
      const environment = getters.currentEnvironment
      const isPremium = getters.isPremium

      // If user is premium, return null to indicate no ads should be shown
      if (isPremium) {
        return null
      }

      const adUnitConfig = state.adUnits[environment]?.[adUnitName]

      if (!adUnitConfig) {
        console.warn(
          `Ad unit configuration not found for: ${environment}.${adUnitName}`
        )
        // Fallback to default values
        return {
          adUnitPath: '/23295702748/ABCD1234',
          adSlotId: 'div-gpt-ad-default',
        }
      }

      return adUnitConfig
    },
  },
})
